import React from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { IconSquareX } from '@tabler/icons-react';

const pickTimestamp = (row, camelKey, snakeKey) => row?.[camelKey] ?? row?.[snakeKey] ?? null;

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ShowCpanelTenantComp = ({ tenant, close }) => {
  const hospitalPath = tenant?.slug ? `/hospitals/${tenant.slug}` : '-';

  return (
    <>
      <Table striped bordered hover size="sm" className="mb-4">
        <tbody>
          <tr>
            <th style={{ width: '35%' }}>Alamat Akses</th>
            <td>
              {tenant?.slug ? (
                <a href={hospitalPath} target="_blank" rel="noreferrer">
                  {hospitalPath}
                </a>
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <th>Slug</th>
            <td>{tenant?.slug || '-'}</td>
          </tr>
          <tr>
            <th>Database/Filestore</th>
            <td>
              {tenant?.stored ? (
                <>
                  <div>{tenant.stored}</div>
                  <div className="text-muted small">public/{tenant.stored}/</div>
                </>
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <th>Deskripsi</th>
            <td>{tenant?.description || '-'}</td>
          </tr>
          <tr>
            <th>Dibuat</th>
            <td>{formatDate(pickTimestamp(tenant, 'createdAt', 'created_at'))}</td>
          </tr>
          <tr>
            <th>Diperbarui</th>
            <td>{formatDate(pickTimestamp(tenant, 'updatedAt', 'updated_at'))}</td>
          </tr>
        </tbody>
      </Table>

      <div className="d-flex justify-content-start">
        <Button variant="danger" size="sm" onClick={close}>
          <IconSquareX stroke={2} className="me-1" />
          Tutup
        </Button>
      </div>
    </>
  );
};

export default ShowCpanelTenantComp;
